import { render } from "./history-card.vue?vue&type=template&id=6564f5ea"
import script from "./history-card.vue?vue&type=script&setup=true&lang=js"
export * from "./history-card.vue?vue&type=script&setup=true&lang=js"

import "./history-card.vue?vue&type=style&index=0&id=6564f5ea&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/history/history-card/history-card.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6564f5ea"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6564f5ea', __exports__)) {
    api.reload('6564f5ea', __exports__)
  }
  
  module.hot.accept("./history-card.vue?vue&type=template&id=6564f5ea", () => {
    api.rerender('6564f5ea', render)
  })

}


export default __exports__